import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import React from 'react'

export interface RemoveProductWarningProps {
    onCancel: VoidFunction
    onRemoveProductListing?: VoidFunction
    isDisplayed: boolean
}

const RemoveProductWarning: React.FC<RemoveProductWarningProps> = ({
    onCancel,
    onRemoveProductListing,
    isDisplayed,
}) => {
    const confirmationDialogContent = React.useMemo(() => {
        return (
            <>
                This action will remove the product listing and its properties
                from your project.
            </>
        )
    }, [])

    return (
        <ConfirmationDialog
            openDialog={isDisplayed}
            handleDialogClose={onCancel}
            dialogActionCallback={onRemoveProductListing!}
            contentNode={confirmationDialogContent}
            size="small"
        />
    )
}

export default RemoveProductWarning
